/*
 * jQuery css bezier animation support -- Jonah Fox
 * version 0.0.1
 * Released under the MIT license.
 */
/*
  var path = $.path.bezier({
    start: {x:10, y:10, angle: 20, length: 0.3},
    end:   {x:20, y:30, angle: -20, length: 0.2}
  })
  $("myobj").animate({path: path}, duration)
*/

;(function($){

  $.path = {};

  var V = {
    rotate: function(p, degrees) {
      var radians = degrees * Math.PI / 180,
        c = Math.cos(radians),
        s = Math.sin(radians);
      return [c*p[0] - s*p[1], s*p[0] + c*p[1]];
    },
    scale: function(p, n) {
      return [n*p[0], n*p[1]];
    },
    add: function(a, b) {
      return [a[0]+b[0], a[1]+b[1]];
    },
    minus: function(a, b) {
      return [a[0]-b[0], a[1]-b[1]];
    }
  };

  $.path.bezier = function( params, rotate ) {
    params.start = $.extend( {angle: 0, length: 0.3333}, params.start );
    params.end = $.extend( {angle: 0, length: 0.3333}, params.end );

    this.p1 = [params.start.x, params.start.y];
    this.p4 = [params.end.x, params.end.y];

    var v14 = V.minus( this.p4, this.p1 ),
      v12 = V.scale( v14, params.start.length ),
      v41 = V.scale( v14, -1 ),
      v43 = V.scale( v41, params.end.length );

    v12 = V.rotate( v12, params.start.angle );
    this.p2 = V.add( this.p1, v12 );

    v43 = V.rotate(v43, params.end.angle );
    this.p3 = V.add( this.p4, v43 );

    this.f1 = function(t) { return (t*t*t); };
    this.f2 = function(t) { return (3*t*t*(1-t)); };
    this.f3 = function(t) { return (3*t*(1-t)*(1-t)); };
    this.f4 = function(t) { return ((1-t)*(1-t)*(1-t)); };

    /* p from 0 to 1 */
    this.css = function(p) {
      var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4=this.f4(p), css = {};
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( this.p1[0]*f1 + this.p2[0]*f2 +this.p3[0]*f3 + this.p4[0]*f4 +.5 )|0;
      css.y = this.y = ( this.p1[1]*f1 + this.p2[1]*f2 +this.p3[1]*f3 + this.p4[1]*f4 +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };

  $.path.arc = function(params, rotate) {
    for ( var i in params ) {
      this[i] = params[i];
    }

    this.dir = this.dir || 1;

    while ( this.start > this.end && this.dir > 0 ) {
      this.start -= 360;
    }

    while ( this.start < this.end && this.dir < 0 ) {
      this.start += 360;
    }

    this.css = function(p) {
      var a = ( this.start * (p ) + this.end * (1-(p )) ) * Math.PI / 180,
        css = {};

      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( Math.sin(a) * this.radius + this.center[0] +.5 )|0;
      css.y = this.y = ( Math.cos(a) * this.radius + this.center[1] +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };

  $.fx.step.path = function(fx) {
    var css = fx.end.css( 1 - fx.pos );
    if ( css.prevX != null ) {
      $.cssHooks.transform.set( fx.elem, "rotate(" + Math.atan2(css.prevY - css.y, css.prevX - css.x) + ")" );
    }
    fx.elem.style.top = css.top;
    fx.elem.style.left = css.left;
  };

})(jQuery);

$(document).ready(function() {
  // Sun Animation at Page Loading....
  $('.sun-image').hide();
  /*
  if ($(window).width() > 767){
    
    var $windowwidth = $(window).width();
    var $windowheight = $(window).height();
    
    var startx1 = $windowwidth * 0.7, starty1 = $windowheight * 0.05,
        endx1 = $windowwidth * 0.8, endy1 = 192 + $windowwidth /3 * 2;//$windowheight * 1;

    var bezier_params1 = {
      start: {
        x: startx1,
        y: starty1,
        angle: 60,
        length: 0.8
      },
      end: {
        x: endx1,
        y: endy1,
        angle: 45,
        length: 1/2
      }
    };
    var bezier1 = new $.path.bezier(bezier_params1);
    
    var $div1 = $("<div>");
    for (var t = 0; t < 1; t += 0.01) {
      var d = $("<span class=dot></span>").css(bezier1.css(t));
      $div1.append(d);
    }
    //$("#jas-wrapper").append($div1);

    
    var startx2 = $windowwidth * 0.05, starty2 = $windowheight * 0.25,
        endx2 = $windowwidth * 0.3, endy2 = $windowheight * 0.95;

    var bezier_params2 = {
      start: {
        x: startx2,
        y: starty2,
        angle: -55,
        length: 2.4
      },
      end: {
        x: endx2,
        y: endy2,
        angle: -20,
        length: 0.8
      }
    };
    
    
    var bezier2 = new $.path.bezier(bezier_params2);

    var $div2 = $("<div>");
    for (var t = 0; t < 1; t += 0.01) {
      var d = $("<span class=dot></span>").css(bezier2.css(t));
      $div2.append(d);
    }
    //$("#jas-wrapper").append($div2);

    
    setTimeout(function(){
      $('#sun-image1').fadeIn(500);  
      $("#sun-image1").animate({path : bezier1}, 6000);
    }, 3000);
    setTimeout(function(){
      $('#sun-image1').fadeOut(500);  
    }, 9000);
    
  }*/
  
  // Initializing ImageList Page
  if ($('.page-imagelist').length) {
    
    $('.page-imagelist img').each(function(index){
      $(this).attr('data-index', index);
    });
    
    $('.image-details .images-wrapper img').each(function(index){
      $(this).attr('id', 'detail-image' + index);
    });
    
    
    $(document).on('click', '.page-imagelist img', function() {
      $('.image-details').show();
      $('body').addClass('modal-open');
      
      var $elementid = '#detail-image' + $(this).data('index');
      var $element = $($elementid);
      var curtop = $('.image-details').scrollTop();
      
      $('.image-details').scrollTop(curtop + $element.position().top);
    });
    
    $('.close-detail').on('click', function() {
      $('.image-details').hide();
      $('body').removeClass('modal-open');
    });
  }
  
});

// ---------------------------------------
  function fixHeight($e){
    $e.height('auto');
    $h	= 0;
    $e.each(function(){
      if($(this).height()>$h) 
        $h = $(this).height();
    });
    $e.height($h);
  }
  function responsiveFixes(){
    fixHeight($('.page-imagelist img'));
  }
  responsiveFixes();
  $(window).load(function(){
    responsiveFixes();
  });
  $(window).resize(function(){
    responsiveFixes();
  });

$('.mobile-dropdown i').on('click', function(event){
  $(this).toggleClass('fa-angle-down');
  $(this).toggleClass('fa-angle-up');
  
  $(this).parent().parent().toggleClass('opened');
  event.preventDefault();
  
});

$('.btn_cart_discount').on('click', function(event) {
  event.preventDefault();
  console.log('cart discount');
});

$(document).ready(function(){
  if ($('#dobyear').length > 0) {
    $.dobPicker({
      daySelector: '#dobday',
      monthSelector: '#dobmonth',
      yearSelector: '#dobyear',
      
      dayDefault: 'Day',
      monthDefault: 'Month',
      yearDefault: 'Year'
    });
  }
  
});

$(document).on('change', '#dobyear', function(){
  $('#Birthday').val($.birthdayString);
});
